import { createI18n, dataGridLocales, isLanguage, type I18n, type Language } from "@manapp/ui"

import en from "./locales/en.json"
import et from "./locales/et.json"
import ru from "./locales/ru.json"

type Catalogue = Record<string, unknown>

// Feature folders own their catalogues (features/<name>/locales/<lang>.json, namespaced by the
// feature); they are merged with the application and grid catalogues.
const featureCatalogues = import.meta.glob<Catalogue>("./features/*/locales/*.json", {
  eager: true,
  import: "default",
})

function merge(target: Catalogue, source: Catalogue): Catalogue {
  const result: Catalogue = { ...target }
  for (const [key, value] of Object.entries(source)) {
    const existing = result[key]
    result[key] =
      typeof value === "object" && value !== null && typeof existing === "object" && existing !== null
        ? merge(existing as Catalogue, value as Catalogue)
        : value
  }
  return result
}

function catalogue(language: Language, base: Catalogue): Catalogue {
  let merged = merge(base, dataGridLocales[language] as Catalogue)
  for (const [path, value] of Object.entries(featureCatalogues)) {
    if (path.endsWith(`/locales/${language}.json`)) merged = merge(merged, value)
  }
  return merged
}

export const resources = {
  en: { translation: catalogue("en", en) },
  et: { translation: catalogue("et", et) },
  ru: { translation: catalogue("ru", ru) },
}

export function browserLanguage(languages: readonly string[] = navigator.languages): Language {
  for (const tag of languages) {
    const primary = tag.split("-")[0]
    if (isLanguage(primary)) return primary
  }
  return "en"
}

export function appI18n(language: Language = browserLanguage()): I18n {
  return createI18n(resources, language)
}
